<template>
  <div>
    <fieldset class="form__field-group">
      <legend class="h4">
        Velg type panel
        <question-icon @onClick="showModal = true"></question-icon>
      </legend>
      <div class="selectable-boxes-container">
        <div
          class="selectable-boxes"
          :class="{ selected: selected === panelType }"
          :key="panelType.internal_id"
          v-for="panelType in panelTypes"
          @click="selected = panelType"
        >
          <div>{{ panelType.name }}</div>
          <div class="selectable-boxes-secondary-text">
            {{ panelType.description }}
          </div>
          <i class="material-icons" hidden>check</i>
        </div>
      </div>
    </fieldset>

    <div
      class="modal"
      :class="{ 'is-visible': showModal }"
      id="panel-selector-modal"
      @keyup.esc="showModal = false"
      @click.self="showModal = false"
      tabindex="0"
    >
      <div class="modal-dialog">
        <header class="modal-header">
          Paneltyper
          <button
            type="button"
            class="close-modal"
            aria-label="close modal"
            @click="showModal = false"
          >
            ✕
          </button>
        </header>
        <section class="modal-content">
          <legend class="h4">Velg paneltype</legend>
          <div class="selectable-boxes-container">
            <div
              class="selectable-boxes"
              :key="panelType.internal_id"
              v-for="panelType in panelTypes"
              @click="
                showModal = false;
                selected = panelType;
              "
            >
              <div class="form__field--radio__card--title">
                {{ panelType.name }}
              </div>
              <img :src="panelType.imgsrc" />
              <div
                v-if="panelType.description"
                class="selectable-boxes-secondary-text"
              >
                <p>{{ panelType.description }}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store';
import QuestionIcon from './QuestionIcon.vue';

const DEFAULT_SELECTED_PANEL_WP = 365;

export default {
  name: 'PanelSelector',
  props: {
    slider: {
      type: String,
    },
  },
  components: {
    QuestionIcon,
  },
  data() {
    return {
      showModal: false,
      selectedType: {},
      panelTypes: [],
      flat: [
        {
          Wp: 365,
          aktiv: true,
          description: '365Wp mot syd',
          excelname: 'Premium',
          flatroof: 'S',
          id: 44,
          imgsrc: 'https://solkart.no/img/monoblack.jpg',
          name: 'Premium Plus 365W',
        },
        {
          Wp: 365,
          aktiv: true,
          description: '365Wp mot øst/vest',
          excelname: 'Premium',
          flatroof: 'EW',
          id: 45,
          imgsrc: 'https://solkart.no/img/monoblack.jpg',
          name: 'Premium Plus 365W',
        },
        {
          Wp: 395,
          aktiv: true,
          description: '395Wp mot syd',
          excelname: 'Performance',
          flatroof: 'S',
          id: 48,
          imgsrc: 'https://solkart.no/img/hyundai.jpg',
          name: 'Performance Plus 395W',
        },
        {
          Wp: 395,
          aktiv: true,
          description: '395Wp mot øst/vest',
          excelname: 'Performance',
          flatroof: 'EW',
          id: 49,
          imgsrc: 'https://solkart.no/img/hyundai.jpg',
          name: 'Performance Plus 395W',
        },
      ],
      slanted: {
        integrated: {
          desc:
            'Vanlige solceller integrert i takflate er en kostnadseffektiv og god løsning. Ved rehabilitering av tak eller for nybygg kan dette være et godt valg. Merk at eksisterende takbelegning må fjernes der panelene skal installeres.',
          name: 'Integrerte',
          types: [
            {
              Wp: 365,
              aktiv: true,
              description: 'Sorte 365Wp',
              excelname: 'Premium',
              flatroof: '',
              id: 43,
              imgsrc: 'https://solkart.no/img/monoblack.jpg',
              name: 'Premium Plus 365W',
            },
            {
              Wp: 395,
              aktiv: true,
              description: 'Sorte 395Wp',
              excelname: 'Performance',
              flatroof: '',
              id: 47,
              imgsrc: 'https://solkart.no/img/hyundai.jpg',
              name: 'Performance Plus 395W',
            },
          ],
        },
        surface: {
          desc:
            'Mest vanlig monteringsløsning for solcellepaneler i Norge, der solcellepanelene legges utenpå yttertaket. Festesystem tilpasses ditt tak.',
          name: 'Overflatemontert',
          types: [
            {
              Wp: 365,
              aktiv: true,
              description: 'Sorte 365Wp',
              excelname: 'Premium',
              flatroof: '',
              id: 42,
              imgsrc: 'https://solkart.no/img/monoblack.jpg',
              name: 'Premium Plus 365W',
            },
            {
              Wp: 395,
              aktiv: true,
              description: 'Sorte 395Wp',
              excelname: 'Performance',
              flatroof: '',
              id: 46,
              imgsrc: 'https://solkart.no/img/hyundai.jpg',
              name: 'Performance Plus 395W',
            },
          ],
        },
      },
    };
  },

  watch: {
    roofType(type) {
      if (type.integrated) {
        this.panelTypes = this.slanted.integrated.types;
        this.selectedType = this.slanted.integrated;
      } else {
        if (this.roofAngle === 'flat') {
          this.panelTypes = this.flat;
        }
        if (this.roofAngle === 'slanted') {
          this.panelTypes = this.slanted.surface.types;
        }
      }
      this.selected = this.panelTypes.find(
        type => type.Wp === DEFAULT_SELECTED_PANEL_WP
      );
    },

    roof(newRoof) {
      if (newRoof === null) {
        this.init();
        return;
      }
      if (newRoof.Helning <= 7) {
        store.commit('setRoofAngle', {
          roofAngle: 'flat',
        });
      } else {
        store.commit('setRoofAngle', {
          roofAngle: 'slanted',
        });
      }

      this.init();
    },
  },
  computed: {
    roofType() {
      return store.state.roofType;
    },
    roof() {
      return store.state.roof;
    },
    roofAngle() {
      return store.state.roofAngle;
    },
    selected: {
      get() {
        return store.state.solarPanelType;
      },
      set(value) {
        store.commit('setSolarPanelType', {
          solarPanelType: value,
        });
      },
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.selectedType = this.slanted.surface;
      this.selected = store.state.solarPanelType;

      if (store.state.roofAngle === 'flat') {
        this.panelTypes = this.flat;
      }
      if (store.state.roofAngle === 'slanted') {
        this.panelTypes = this.slanted.surface.types;
      }

      if (store.state.roofType && store.state.roofType.excelname === 'Nytt') {
        this.panelTypes = this.slanted.integrated.types;
        this.selectedType = this.slanted.integrated;
      }

      this.selected = this.panelTypes.find(
        type => type.Wp === DEFAULT_SELECTED_PANEL_WP
      );
    },
    selectType(type) {
      let index = this.panelTypes.indexOf(this.selected);
      if (type.name === this.slanted.surface.name) {
        this.panelTypes = this.slanted.surface.types;
        this.selectedType = this.slanted.surface;
      }

      if (type.name === this.slanted.integrated.name) {
        this.panelTypes = this.slanted.integrated.types;
        this.selectedType = this.slanted.integrated;
      }

      if (index < this.panelTypes.length) {
        this.selected = this.panelTypes[index];
      } else {
        this.selected = this.panelTypes.find(
          type => type.Wp === DEFAULT_SELECTED_PANEL_WP
        );
      }
    },
  },
};
</script>

<style scoped src="../assets/css/selectable-boxes.css"></style>
